<template>
  <span class="relation-badges">
    <span v-if="isOwner" class="badge alert-prim">Owner</span>
    <span v-if="isRider" class="badge alert-secondary">Rider</span>
    <span v-if="!isOwner && !isRider" class="badge alert-dark">Family</span>
  </span>
</template>

<script>
/**
 * The Owner/Rider/Family badge group, shared by the Member Profile "Horses" tab (CAM-1505) and
 * the Horse Profile "Members" tab (CAM-1504) — both render it inside ListNameCell's #badges
 * slot, next to that list's own status badges. `isOwner`/`isRider` name the row's own direct
 * link; neither true means the row is visible only via another family member (see
 * HorseMemberRelation on the API side).
 *
 * `display: contents` on the wrapper (below) keeps this component invisible to layout — its
 * 1-3 badge spans become direct flex items of ListNameCell's `.list-name-cell__badges`, exactly
 * as if they were written inline there, so the existing gap/wrap CSS still applies to each badge.
 *
 *   <horse-member-relation-badges :is-owner="row.isOwner" :is-rider="row.isRider" />
 */
export default {
  name: 'HorseMemberRelationBadges',
  props: {
    isOwner: { type: Boolean, default: false },
    isRider: { type: Boolean, default: false }
  }
}
</script>

<style scoped>
.relation-badges {
  display: contents;
}
</style>



// WEBPACK FOOTER //
// src/components/HorseMemberRelationBadges.vue